<template>
  <v-card flat>
    <v-card-text>
      <v-text-field
        :label="$t('user.form.labels.email')"
        :error="(error.email || []).length > 0"
        :rules="error.email"
        v-model="email"
        type="email" />
      <v-text-field
        :label="$t('user.form.labels.password')"
        :error="(error.password || []).length > 0"
        :rules="error.password"
        v-model="password"
        type="password" />
      <v-text-field
        :label="$t('user.form.labels.passwordConfirmation')"
        :error="(error.password_confirmation || []).length > 0"
        :rules="error.password_confirmation"
        v-model="passwordConfirmation"
        type="password" />
      <v-checkbox :label="$t('user.form.labels.sendEmail')" v-model="sendEmail" />
    </v-card-text>
    <v-divider />
    <v-card-row actions>
      <v-btn
        class="ml-2"
        @click.native.stop="submit()"
        primary light ripple
        :loading="loading">
        {{ $t('user.form.save') }}
      </v-btn>
    </v-card-row>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      error: {},
      sendEmail: true,
      email: null,
      password: null,
      passwordConfirmation: null
    }
  },
  computed: mapGetters({
    loading: 'skiliko/users/isLoading'
  }),
  methods: {
    ...mapActions({
      create: 'skiliko/users/create'
    }),
    clear () {
      this.email = this.password = this.passwordConfirmation = null
    },
    submit () {
      this.error = {}
      return this.create({
        email: this.email,
        password: this.password,
        password_confirmation: this.passwordConfirmation,
        email_notification: this.sendEmail
      })
        .then(user => {
          this.clear()
          this.$emit('created', user)
        })
        .catch(({ response }) => (this.error = (response || {}).data || {}))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/Form.vue